// extracted by mini-css-extract-plugin
module.exports = {"share":"styles_share__jFZS8","icons":"styles_icons__5uqYZ"};